import { useQuery } from 'react-query';

import { useApi } from '../../context/ApiContext';

export const useGetKamListForManager = () => {
  const client = useApi();

  return useQuery('get-kam-list', () => client.get('/multiaccess/manager/kamList').then((res) => res.data));
};
